module.exports = __webpack_public_path__ + "static/media/zPOS_logo.57ce06c2.svg";